import { ApiClient } from '../client'
import { AuthMeResponse, RegisterRequest, UpdateProfileRequest, ChangePasswordRequest, ApiResponse } from '../types'

export class AuthApi {
  constructor(private client: ApiClient) {}

  async login(credentials: { email: string; password: string }): Promise<{ token: string; user: any }> {
    return this.client.post<{ token: string; user: any }>('/v1/auth/login', credentials)
  }

  async me(): Promise<any> {
    const response = await this.client.get<any>('/v1/auth/me')
    
    // Handle wrapped or unwrapped response
    if (response && typeof response === 'object') {
      if ('data' in response && response.data) {
        return response.data
      }
      return response
    }
    
    throw new Error('Invalid auth response format')
  }

  async getCurrentUser(): Promise<AuthMeResponse> {
    return this.me()
  }

  async register(data: RegisterRequest): Promise<{ token: string; user: any }> {
    return this.client.post<{ token: string; user: any }>('/v1/auth/register', data)
  }

  async refreshToken(): Promise<{ token: string }> {
    return this.client.post<{ token: string }>('/v1/auth/refresh', {})
  }

  async logout(): Promise<void> {
    return this.client.post<void>('/v1/auth/logout', {})
  }

  async updateProfile(data: UpdateProfileRequest): Promise<AuthMeResponse> {
    const response = await this.client.put<any>('/v1/auth/profile', data)
    return response?.data || response
  }

  async changePassword(data: ChangePasswordRequest): Promise<{ success: boolean; message: string }> {
    const response = await this.client.post<any>('/v1/auth/change-password', data)
    return response?.data || response
  }
}
